
import { Game } from "@/models/Game";
import { Component, Vue, Prop } from "vue-property-decorator";
import ActionBox from "@/components/Base/Actions/ActionBox.vue";
import { Dialog_Questions } from "@/models/MapPois/Quest/QuestMapPoi";
import { DropDownItem } from "@/models/Base/GlobalData";
import { Season } from "@/models/GameType";
import { ActionList } from "@/models/MapPois/Quest/Actions";
import { Validations } from "vuelidate-property-decorators";
import { required, minLength, maxLength } from "vuelidate/lib/validators";

@Component({
  components: { ActionBox },
})
class DialogQuestions extends Vue {
  @Prop({ default: null }) readonly questionData!: Dialog_Questions;
  @Prop({ default: true }) readonly isEditingLocked!: boolean;
  @Prop({ default: true }) readonly gameData!: Game;

  questionObj = {};

  get getModelID(): string {
    return "team-modal-sure" + this.getQuestionData.id;
  }

  get getQuestionData(): Dialog_Questions {
    return this.questionData;
  }

  get getContentData(): ActionList {
    return this.getQuestionData.actions || ({} as ActionList);
  }

  get getSeason(): Season {
    return this.$store.state.gameStore.gameType.filter(
      (t: Season) => t.slug == this.gameData.seas_uid
    )[0];
  }

  get getInventoryItems(): DropDownItem[] {
    var inv_items = Object.values(this.getSeason.inv_items);
    var invNames: DropDownItem[] = [];
    invNames.push({
      text: "None",
      value: "",
    });
    inv_items.forEach((x) => {
      invNames.push({
        text: x.name.en,
        value: x.slug,
      });
    });
    return invNames;
  }

  created(): void {
    this.$store.dispatch("gameStore/getGameTypes", "quest");
  }

  updateQuestionActions(contentData: any): void {
    this.questionData.actions = contentData.contentData;
    this.questionObj = {
      contentData: contentData,
      questionData: this.questionData,
    };
    this.$emit("updateData", this.questionObj);
  }

  onInventoryChange(value: any): void {
    if (value === "none") {
      this.questionData.cost!.value = 0;
    }
    this.questionObj = {
      contentData: null,
      questionData: this.questionData,
    };
    this.$emit("updateData", this.questionObj);
  }

  onValueChanged(): void {
    this.questionObj = {
      contentData: null,
      questionData: this.questionData,
    };
    this.$emit("updateData", this.questionObj);
  }

  deleteQuestionActions(contentData: any): void {
    if (this.questionData.actions !== undefined) {
      this.questionData.actions = contentData.contentData;
      this.$emit("deleteData", this.getContentData);
    }
  }
  openDialog(): void {
    if (!this.isEditingLocked) {
      this.$bvModal.show(this.getModelID);
    }
  }

  deleteQuestion(): void {
    this.$emit("deleteQuestion", this.questionData.id);
    this.$bvModal.hide(this.getModelID);
  }
  close(): void {
    this.$bvModal.hide(this.getModelID);
  }

  @Validations()
  validations = {
    questionData: {
      q: {
        en: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(160),
        },
      },
      a: {
        en: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(160),
        },
      },
    },
  };
}
export default DialogQuestions;
